<div
  [formGroup]="form"
  class="form-check pr-3 d-inline-block"
  ngbTooltip="{{
    'documents.document-item-track-inventory.tooltip' | translate
  }}"
  position="left"
>
  <input
    class="form-check-input"
    type="checkbox"
    id="trackInventory"
    formControlName="trackInventory"
  />
  <label class="form-check-label" for="trackInventory">
    <i class="fe fe-package"></i>
    <i
      class="fas fa-lock ml-2 text-warning fa-xs"
      *ngIf="(hasInventoryAddon | async) === false"
    ></i>
  </label>
</div>
